const styles = {
  wrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '20px',
    gap: '16px',
  },
  submitButton: {
    backgroundColor: 'green',
    color: 'white',
    '&:hover, &:focus': {
      backgroundColor: 'ligherGreen',
    },
    '&.Mui-disabled': {
      backgroundColor: 'ligherGray',
      color: '#FFFFFF',
    },
  },
};

export default styles;
